import { Component } from '@angular/core';
@Component({
    selector: 'page-404',
    templateUrl: './404.component.html',
    styleUrls: ['./404.component.css']
})

export class NotFoundPage {

    public lottieConfig: Object;
    private anim: any;
    private animationSpeed: number = 1;

    constructor() {
        this.lottieConfig = {
            path: 'assets/images/404_page.json',
            renderer: 'canvas',
            autoplay: true,
            loop: true
        };
    }

    handleAnimation(anim: any) {
        this.anim = anim;
    }

}